// store/Automation/reducer.js

import {
  AUTOMATION_SCENARIO_LIST,
  AUTOMATION_SCENARIO_LIST_SUCCESS,
  AUTOMATION_SCENARIO_LIST_FAILURE,
  AUTOMATION_SCENARIO_STATUS_LIST,
  AUTOMATION_SCENARIO_STATUS_LIST_SUCCESS,
  AUTOMATION_SCENARIO_STATUS_LIST_FAILURE,
  AUTOMATION_CANVAS,
  AUTOMATION_CANVAS_SUCCESS,
  AUTOMATION_CANVAS_FAILURE,
  AUTOMATION_SCENARIO_CREATE,
  AUTOMATION_SCENARIO_CREATE_SUCCESS,
  AUTOMATION_SCENARIO_CREATE_FAILURE,
  AUTOMATION_SCENARIO_UPDATE,
  AUTOMATION_SCENARIO_UPDATE_SUCCESS,
  AUTOMATION_SCENARIO_UPDATE_FAILURE,
  AUTOMATION_SCENARIO_PUBLISH,
  AUTOMATION_SCENARIO_PUBLISH_SUCCESS,
  AUTOMATION_SCENARIO_PUBLISH_FAILURE,
  AUTOMATION_SCENARIO_DUPLICATE,
  AUTOMATION_SCENARIO_DUPLICATE_SUCCESS,
  AUTOMATION_SCENARIO_DUPLICATE_FAILURE,
  AUTOMATION_SCENARIO_DISABLE,
  AUTOMATION_SCENARIO_DISABLE_SUCCESS,
  AUTOMATION_SCENARIO_DISABLE_FAILURE,
  AUTOMATION_SCENARIO_DELETE,
  AUTOMATION_SCENARIO_DELETE_SUCCESS,
  AUTOMATION_SCENARIO_DELETE_FAILURE,
  AUTOMATION_NODE_CREATE,
  AUTOMATION_NODE_CREATE_SUCCESS,
  AUTOMATION_NODE_CREATE_FAILURE,
  AUTOMATION_NODE_UPDATE,
  AUTOMATION_NODE_UPDATE_SUCCESS,
  AUTOMATION_NODE_UPDATE_FAILURE,
  AUTOMATION_NODE_DELETE,
  AUTOMATION_NODE_DELETE_SUCCESS,
  AUTOMATION_NODE_DELETE_FAILURE,
  AUTOMATION_LINK_CREATE,
  AUTOMATION_LINK_CREATE_SUCCESS,
  AUTOMATION_LINK_CREATE_FAILURE,
  AUTOMATION_LINK_DELETE,
  AUTOMATION_LINK_DELETE_SUCCESS,
  AUTOMATION_LINK_DELETE_FAILURE,
  AUTOMATION_BLOCK_CONFIG_FIELDS,
  AUTOMATION_BLOCK_CONFIG_FIELDS_SUCCESS,
  AUTOMATION_BLOCK_CONFIG_FIELDS_FAILURE,
  AUTOMATION_NODE_CONFIG_SAVE,
  AUTOMATION_NODE_CONFIG_SAVE_SUCCESS,
  AUTOMATION_NODE_CONFIG_SAVE_FAILURE,
  AUTOMATION_NODE_CONFIG_DELETE,
  AUTOMATION_NODE_CONFIG_DELETE_SUCCESS,
  AUTOMATION_NODE_CONFIG_DELETE_FAILURE,
  AUTOMATION_DELAY_CREATE,
  AUTOMATION_DELAY_CREATE_SUCCESS,
  AUTOMATION_DELAY_CREATE_FAILURE,
  AUTOMATION_DELAY_UPDATE,
  AUTOMATION_DELAY_UPDATE_SUCCESS,
  AUTOMATION_DELAY_UPDATE_FAILURE,
  AUTOMATION_CONDITION_GROUP_CREATE,
  AUTOMATION_CONDITION_GROUP_CREATE_SUCCESS,
  AUTOMATION_CONDITION_GROUP_CREATE_FAILURE,
  AUTOMATION_CONDITION_GROUP_UPDATE,
  AUTOMATION_CONDITION_GROUP_UPDATE_SUCCESS,
  AUTOMATION_CONDITION_GROUP_UPDATE_FAILURE,
  AUTOMATION_CONDITION_GROUP_DELETE,
  AUTOMATION_CONDITION_GROUP_DELETE_SUCCESS,
  AUTOMATION_CONDITION_GROUP_DELETE_FAILURE,
  AUTOMATION_CONDITION_RULE_CREATE,
  AUTOMATION_CONDITION_RULE_CREATE_SUCCESS,
  AUTOMATION_CONDITION_RULE_CREATE_FAILURE,
  AUTOMATION_CONDITION_RULE_UPDATE,
  AUTOMATION_CONDITION_RULE_UPDATE_SUCCESS,
  AUTOMATION_CONDITION_RULE_UPDATE_FAILURE,
  AUTOMATION_CONDITION_RULE_DELETE,
  AUTOMATION_CONDITION_RULE_DELETE_SUCCESS,
  AUTOMATION_CONDITION_RULE_DELETE_FAILURE,
  AUTOMATION_EXECUTION_LIST,
  AUTOMATION_EXECUTION_LIST_SUCCESS,
  AUTOMATION_EXECUTION_LIST_FAILURE,
  AUTOMATION_EXECUTION_DATA,
  AUTOMATION_EXECUTION_DATA_SUCCESS,
  AUTOMATION_EXECUTION_DATA_FAILURE,
  AUTOMATION_EXECUTION_TRIGGER,
  AUTOMATION_EXECUTION_TRIGGER_SUCCESS,
  AUTOMATION_EXECUTION_TRIGGER_FAILURE,
  AUTOMATION_EXECUTION_STATUS_LIST,
  AUTOMATION_EXECUTION_STATUS_LIST_SUCCESS,
  AUTOMATION_EXECUTION_STATUS_LIST_FAILURE,
} from "./actionType";

const initialState = {
  //reads
  scenarioListLoading: false,
  scenarioList: [],
  scenarioListError: null,

  scenarioStatusListLoading: false,
  scenarioStatusList: [],
  scenarioStatusListError: null,

  canvasLoading: false,
  canvas: null,
  canvasError: null,
  // bumped on any structural mutation success so the page can re-pull the canvas
  canvasDirtyAt: 0,

  blockConfigFieldsLoading: false,
  blockConfigFields: {}, // keyed by blockId
  blockConfigFieldsError: null,

  executionListLoading: false,
  executionList: [],
  executionListError: null,

  executionDataLoading: false,
  executionData: null,
  executionDataError: null,

  executionStatusListLoading: false,
  executionStatusList: [],
  executionStatusListError: null,

  //scenario lifecycle
  scenarioCreateLoading: false,
  scenarioCreateSuccess: null,
  scenarioCreateError: null,
  scenarioUpdateLoading: false,
  scenarioUpdateSuccess: null,
  scenarioUpdateError: null,
  scenarioPublishLoading: false,
  scenarioPublishSuccess: null,
  scenarioPublishError: null,
  scenarioDuplicateLoading: false,
  scenarioDuplicateSuccess: null,
  scenarioDuplicateError: null,
  scenarioDisableLoading: false,
  scenarioDisableSuccess: null,
  scenarioDisableError: null,
  scenarioDeleteLoading: false,
  scenarioDeleteSuccess: null,
  scenarioDeleteError: null,

  //node
  nodeCreateLoading: false,
  nodeCreateSuccess: null,
  nodeCreateError: null,
  nodeUpdateLoading: false,
  nodeUpdateSuccess: null,
  nodeUpdateError: null,
  nodeDeleteLoading: false,
  nodeDeleteSuccess: null,
  nodeDeleteError: null,

  //link
  linkCreateLoading: false,
  linkCreateSuccess: null,
  linkCreateError: null,
  linkDeleteLoading: false,
  linkDeleteSuccess: null,
  linkDeleteError: null,

  //node config
  nodeConfigSaveLoading: false,
  nodeConfigSaveSuccess: null,
  nodeConfigSaveError: null,
  nodeConfigDeleteLoading: false,
  nodeConfigDeleteSuccess: null,
  nodeConfigDeleteError: null,

  //delay
  delayCreateLoading: false,
  delayCreateSuccess: null,
  delayCreateError: null,
  delayUpdateLoading: false,
  delayUpdateSuccess: null,
  delayUpdateError: null,

  //condition group
  conditionGroupCreateLoading: false,
  conditionGroupCreateSuccess: null,
  conditionGroupCreateError: null,
  conditionGroupUpdateLoading: false,
  conditionGroupUpdateSuccess: null,
  conditionGroupUpdateError: null,
  conditionGroupDeleteLoading: false,
  conditionGroupDeleteSuccess: null,
  conditionGroupDeleteError: null,

  //condition rule
  conditionRuleCreateLoading: false,
  conditionRuleCreateSuccess: null,
  conditionRuleCreateError: null,
  conditionRuleUpdateLoading: false,
  conditionRuleUpdateSuccess: null,
  conditionRuleUpdateError: null,
  conditionRuleDeleteLoading: false,
  conditionRuleDeleteSuccess: null,
  conditionRuleDeleteError: null,

  //execution trigger
  executionTriggerLoading: false,
  executionTriggerSuccess: null,
  executionTriggerError: null,
};

const dirty = () => Date.now();

const automationReducer = (state = initialState, action) => {
  switch (action.type) {
    //=== reads ===
    case AUTOMATION_SCENARIO_LIST:
      return { ...state, scenarioListLoading: true, scenarioListError: null };
    case AUTOMATION_SCENARIO_LIST_SUCCESS:
      return { ...state, scenarioListLoading: false, scenarioList: action.payload };
    case AUTOMATION_SCENARIO_LIST_FAILURE:
      return { ...state, scenarioListLoading: false, scenarioListError: action.payload };

    case AUTOMATION_SCENARIO_STATUS_LIST:
      return { ...state, scenarioStatusListLoading: true, scenarioStatusListError: null };
    case AUTOMATION_SCENARIO_STATUS_LIST_SUCCESS:
      return { ...state, scenarioStatusListLoading: false, scenarioStatusList: action.payload };
    case AUTOMATION_SCENARIO_STATUS_LIST_FAILURE:
      return { ...state, scenarioStatusListLoading: false, scenarioStatusListError: action.payload };

    case AUTOMATION_CANVAS:
      return { ...state, canvasLoading: true, canvasError: null };
    case AUTOMATION_CANVAS_SUCCESS:
      return { ...state, canvasLoading: false, canvas: action.payload };
    case AUTOMATION_CANVAS_FAILURE:
      return { ...state, canvasLoading: false, canvasError: action.payload };

    case AUTOMATION_BLOCK_CONFIG_FIELDS:
      return { ...state, blockConfigFieldsLoading: true, blockConfigFieldsError: null };
    case AUTOMATION_BLOCK_CONFIG_FIELDS_SUCCESS:
      return {
        ...state,
        blockConfigFieldsLoading: false,
        blockConfigFields: {
          ...state.blockConfigFields,
          [action.payload.blockId]: action.payload.fields,
        },
      };
    case AUTOMATION_BLOCK_CONFIG_FIELDS_FAILURE:
      return { ...state, blockConfigFieldsLoading: false, blockConfigFieldsError: action.payload };

    case AUTOMATION_EXECUTION_LIST:
      return { ...state, executionListLoading: true, executionListError: null };
    case AUTOMATION_EXECUTION_LIST_SUCCESS:
      return { ...state, executionListLoading: false, executionList: action.payload };
    case AUTOMATION_EXECUTION_LIST_FAILURE:
      return { ...state, executionListLoading: false, executionListError: action.payload };

    case AUTOMATION_EXECUTION_DATA:
      return { ...state, executionDataLoading: true, executionDataError: null };
    case AUTOMATION_EXECUTION_DATA_SUCCESS:
      return { ...state, executionDataLoading: false, executionData: action.payload };
    case AUTOMATION_EXECUTION_DATA_FAILURE:
      return { ...state, executionDataLoading: false, executionDataError: action.payload };

    case AUTOMATION_EXECUTION_STATUS_LIST:
      return { ...state, executionStatusListLoading: true, executionStatusListError: null };
    case AUTOMATION_EXECUTION_STATUS_LIST_SUCCESS:
      return { ...state, executionStatusListLoading: false, executionStatusList: action.payload };
    case AUTOMATION_EXECUTION_STATUS_LIST_FAILURE:
      return { ...state, executionStatusListLoading: false, executionStatusListError: action.payload };

    //=== scenario lifecycle ===
    case AUTOMATION_SCENARIO_CREATE:
      return { ...state, scenarioCreateLoading: true, scenarioCreateSuccess: null, scenarioCreateError: null };
    case AUTOMATION_SCENARIO_CREATE_SUCCESS:
      return { ...state, scenarioCreateLoading: false, scenarioCreateSuccess: action.payload };
    case AUTOMATION_SCENARIO_CREATE_FAILURE:
      return { ...state, scenarioCreateLoading: false, scenarioCreateError: action.payload };

    case AUTOMATION_SCENARIO_UPDATE:
      return { ...state, scenarioUpdateLoading: true, scenarioUpdateError: null };
    case AUTOMATION_SCENARIO_UPDATE_SUCCESS:
      return { ...state, scenarioUpdateLoading: false, scenarioUpdateSuccess: action.payload };
    case AUTOMATION_SCENARIO_UPDATE_FAILURE:
      return { ...state, scenarioUpdateLoading: false, scenarioUpdateError: action.payload };

    case AUTOMATION_SCENARIO_PUBLISH:
      return { ...state, scenarioPublishLoading: true, scenarioPublishSuccess: null, scenarioPublishError: null };
    case AUTOMATION_SCENARIO_PUBLISH_SUCCESS:
      return { ...state, scenarioPublishLoading: false, scenarioPublishSuccess: action.payload, canvasDirtyAt: dirty() };
    case AUTOMATION_SCENARIO_PUBLISH_FAILURE:
      return { ...state, scenarioPublishLoading: false, scenarioPublishError: action.payload };

    case AUTOMATION_SCENARIO_DUPLICATE:
      return { ...state, scenarioDuplicateLoading: true, scenarioDuplicateSuccess: null, scenarioDuplicateError: null };
    case AUTOMATION_SCENARIO_DUPLICATE_SUCCESS:
      return { ...state, scenarioDuplicateLoading: false, scenarioDuplicateSuccess: action.payload };
    case AUTOMATION_SCENARIO_DUPLICATE_FAILURE:
      return { ...state, scenarioDuplicateLoading: false, scenarioDuplicateError: action.payload };

    case AUTOMATION_SCENARIO_DISABLE:
      return { ...state, scenarioDisableLoading: true, scenarioDisableSuccess: null, scenarioDisableError: null };
    case AUTOMATION_SCENARIO_DISABLE_SUCCESS:
      return { ...state, scenarioDisableLoading: false, scenarioDisableSuccess: action.payload, canvasDirtyAt: dirty() };
    case AUTOMATION_SCENARIO_DISABLE_FAILURE:
      return { ...state, scenarioDisableLoading: false, scenarioDisableError: action.payload };

    case AUTOMATION_SCENARIO_DELETE:
      return { ...state, scenarioDeleteLoading: true, scenarioDeleteSuccess: null, scenarioDeleteError: null };
    case AUTOMATION_SCENARIO_DELETE_SUCCESS:
      return { ...state, scenarioDeleteLoading: false, scenarioDeleteSuccess: action.payload };
    case AUTOMATION_SCENARIO_DELETE_FAILURE:
      return { ...state, scenarioDeleteLoading: false, scenarioDeleteError: action.payload };

    //=== node (structural -> bump canvasDirtyAt) ===
    case AUTOMATION_NODE_CREATE:
      return { ...state, nodeCreateLoading: true, nodeCreateSuccess: null, nodeCreateError: null };
    case AUTOMATION_NODE_CREATE_SUCCESS:
      return { ...state, nodeCreateLoading: false, nodeCreateSuccess: action.payload, canvasDirtyAt: dirty() };
    case AUTOMATION_NODE_CREATE_FAILURE:
      return { ...state, nodeCreateLoading: false, nodeCreateError: action.payload };

    case AUTOMATION_NODE_UPDATE:
      return { ...state, nodeUpdateLoading: true, nodeUpdateError: null };
    case AUTOMATION_NODE_UPDATE_SUCCESS:
      return { ...state, nodeUpdateLoading: false, nodeUpdateSuccess: action.payload };
    case AUTOMATION_NODE_UPDATE_FAILURE:
      return { ...state, nodeUpdateLoading: false, nodeUpdateError: action.payload };

    case AUTOMATION_NODE_DELETE:
      return { ...state, nodeDeleteLoading: true, nodeDeleteError: null };
    case AUTOMATION_NODE_DELETE_SUCCESS:
      return { ...state, nodeDeleteLoading: false, nodeDeleteSuccess: action.payload, canvasDirtyAt: dirty() };
    case AUTOMATION_NODE_DELETE_FAILURE:
      return { ...state, nodeDeleteLoading: false, nodeDeleteError: action.payload };

    //=== link (structural) ===
    case AUTOMATION_LINK_CREATE:
      return { ...state, linkCreateLoading: true, linkCreateError: null };
    case AUTOMATION_LINK_CREATE_SUCCESS:
      return { ...state, linkCreateLoading: false, linkCreateSuccess: action.payload, canvasDirtyAt: dirty() };
    case AUTOMATION_LINK_CREATE_FAILURE:
      return { ...state, linkCreateLoading: false, linkCreateError: action.payload };

    case AUTOMATION_LINK_DELETE:
      return { ...state, linkDeleteLoading: true, linkDeleteError: null };
    case AUTOMATION_LINK_DELETE_SUCCESS:
      return { ...state, linkDeleteLoading: false, linkDeleteSuccess: action.payload, canvasDirtyAt: dirty() };
    case AUTOMATION_LINK_DELETE_FAILURE:
      return { ...state, linkDeleteLoading: false, linkDeleteError: action.payload };

    //=== node config (in-place, no reload) ===
    case AUTOMATION_NODE_CONFIG_SAVE:
      return { ...state, nodeConfigSaveLoading: true, nodeConfigSaveError: null };
    case AUTOMATION_NODE_CONFIG_SAVE_SUCCESS:
      return { ...state, nodeConfigSaveLoading: false, nodeConfigSaveSuccess: action.payload };
    case AUTOMATION_NODE_CONFIG_SAVE_FAILURE:
      return { ...state, nodeConfigSaveLoading: false, nodeConfigSaveError: action.payload };

    case AUTOMATION_NODE_CONFIG_DELETE:
      return { ...state, nodeConfigDeleteLoading: true, nodeConfigDeleteError: null };
    case AUTOMATION_NODE_CONFIG_DELETE_SUCCESS:
      return { ...state, nodeConfigDeleteLoading: false, nodeConfigDeleteSuccess: action.payload };
    case AUTOMATION_NODE_CONFIG_DELETE_FAILURE:
      return { ...state, nodeConfigDeleteLoading: false, nodeConfigDeleteError: action.payload };

    //=== delay ===
    case AUTOMATION_DELAY_CREATE:
      return { ...state, delayCreateLoading: true, delayCreateError: null };
    case AUTOMATION_DELAY_CREATE_SUCCESS:
      return { ...state, delayCreateLoading: false, delayCreateSuccess: action.payload, canvasDirtyAt: dirty() };
    case AUTOMATION_DELAY_CREATE_FAILURE:
      return { ...state, delayCreateLoading: false, delayCreateError: action.payload };

    case AUTOMATION_DELAY_UPDATE:
      return { ...state, delayUpdateLoading: true, delayUpdateError: null };
    case AUTOMATION_DELAY_UPDATE_SUCCESS:
      return { ...state, delayUpdateLoading: false, delayUpdateSuccess: action.payload };
    case AUTOMATION_DELAY_UPDATE_FAILURE:
      return { ...state, delayUpdateLoading: false, delayUpdateError: action.payload };

    //=== condition group (structural) ===
    case AUTOMATION_CONDITION_GROUP_CREATE:
      return { ...state, conditionGroupCreateLoading: true, conditionGroupCreateError: null };
    case AUTOMATION_CONDITION_GROUP_CREATE_SUCCESS:
      return { ...state, conditionGroupCreateLoading: false, conditionGroupCreateSuccess: action.payload, canvasDirtyAt: dirty() };
    case AUTOMATION_CONDITION_GROUP_CREATE_FAILURE:
      return { ...state, conditionGroupCreateLoading: false, conditionGroupCreateError: action.payload };

    case AUTOMATION_CONDITION_GROUP_UPDATE:
      return { ...state, conditionGroupUpdateLoading: true, conditionGroupUpdateError: null };
    case AUTOMATION_CONDITION_GROUP_UPDATE_SUCCESS:
      return { ...state, conditionGroupUpdateLoading: false, conditionGroupUpdateSuccess: action.payload };
    case AUTOMATION_CONDITION_GROUP_UPDATE_FAILURE:
      return { ...state, conditionGroupUpdateLoading: false, conditionGroupUpdateError: action.payload };

    case AUTOMATION_CONDITION_GROUP_DELETE:
      return { ...state, conditionGroupDeleteLoading: true, conditionGroupDeleteError: null };
    case AUTOMATION_CONDITION_GROUP_DELETE_SUCCESS:
      return { ...state, conditionGroupDeleteLoading: false, conditionGroupDeleteSuccess: action.payload, canvasDirtyAt: dirty() };
    case AUTOMATION_CONDITION_GROUP_DELETE_FAILURE:
      return { ...state, conditionGroupDeleteLoading: false, conditionGroupDeleteError: action.payload };

    //=== condition rule (structural) ===
    case AUTOMATION_CONDITION_RULE_CREATE:
      return { ...state, conditionRuleCreateLoading: true, conditionRuleCreateError: null };
    case AUTOMATION_CONDITION_RULE_CREATE_SUCCESS:
      return { ...state, conditionRuleCreateLoading: false, conditionRuleCreateSuccess: action.payload, canvasDirtyAt: dirty() };
    case AUTOMATION_CONDITION_RULE_CREATE_FAILURE:
      return { ...state, conditionRuleCreateLoading: false, conditionRuleCreateError: action.payload };

    case AUTOMATION_CONDITION_RULE_UPDATE:
      return { ...state, conditionRuleUpdateLoading: true, conditionRuleUpdateError: null };
    case AUTOMATION_CONDITION_RULE_UPDATE_SUCCESS:
      return { ...state, conditionRuleUpdateLoading: false, conditionRuleUpdateSuccess: action.payload };
    case AUTOMATION_CONDITION_RULE_UPDATE_FAILURE:
      return { ...state, conditionRuleUpdateLoading: false, conditionRuleUpdateError: action.payload };

    case AUTOMATION_CONDITION_RULE_DELETE:
      return { ...state, conditionRuleDeleteLoading: true, conditionRuleDeleteError: null };
    case AUTOMATION_CONDITION_RULE_DELETE_SUCCESS:
      return { ...state, conditionRuleDeleteLoading: false, conditionRuleDeleteSuccess: action.payload, canvasDirtyAt: dirty() };
    case AUTOMATION_CONDITION_RULE_DELETE_FAILURE:
      return { ...state, conditionRuleDeleteLoading: false, conditionRuleDeleteError: action.payload };

    //=== execution trigger ===
    case AUTOMATION_EXECUTION_TRIGGER:
      return { ...state, executionTriggerLoading: true, executionTriggerSuccess: null, executionTriggerError: null };
    case AUTOMATION_EXECUTION_TRIGGER_SUCCESS:
      return { ...state, executionTriggerLoading: false, executionTriggerSuccess: action.payload };
    case AUTOMATION_EXECUTION_TRIGGER_FAILURE:
      return { ...state, executionTriggerLoading: false, executionTriggerError: action.payload };

    default:
      return state;
  }
};

export default automationReducer;
